const obj = {
    liveBroadcast:{
        announcement: '/web/chatroom/notice', //新建聊天室公告
        getBroadcastList: '/web/broadcast/getBroadcastList',//直播列表获取
        getForbiddenUserList:'/web/chatroom/getForbiddenUserList/',//直播禁言列表
        create: '/web/broadcast/create',//直播间创建
        forbiddenUser:'/web/chatroom/forbiddenUser/',//禁言 解禁用户
        getNoticeList:'/web/chatroom/getNoticeList/', //获取公告列表
        getBroadcastDetail:'/web/broadcast/getBroadcastDetail/', //直播详情获取
        setting:'/web/broadcast/setting',//获取直播配置
        notice:'/web/chatroom/notice', //新建聊天室公告
        accid:'/web/chatroom//accid/',/* 获取云信通讯ID */
        checkNotice:'/web/chatroom/notice/',//查看公告详情
        stopNotice:'/web/chatroom/notice/',//公告停用
        info:'/web/broadcast/info',//直播间信息查询
        edit: '/web/broadcast/info/edit', //直播信息编辑
        add:'/web/broadcast/info/add',//直播信息新增
        changeOredr:'/web/broadcast/getGoodsList/changeOredr', //商品顺序交换
        couponNotSelect:'/web/broadcast/getCouponList/notSelect',//优惠券未选列表
        couponSelect:'/web/broadcast/getCouponList/select',//优惠券已选列表
        couponAdd: '/web/broadcast/getCouponList/add/',//优惠券添加
        couponDel: '/web/broadcast/getCouponList/del/', //优惠券撤销（删除
        syncInfo:'/web/broadcast/syncInfo/', //同步信息到直播间
        goodsNotSelect:'/web/broadcast/getGoodsList/notSelect', //商品未选列表
        goodsSelect:'/web/broadcast/getGoodsList/select',//商品已选列表
        goodsAdd:'/web/broadcast/getGoodsList/add/',//商品添加
        goodsDel:'/web/broadcast/getGoodsList/del/',//商品删除
        remove:'web/broadcast/remove/',//直播删除
        liveEdit:'web/broadcast/edit',//直播编辑
        queryEdit:'web/broadcast/queryEdit/', //直播编辑回显
        changeState:'/web/broadcast/getCouponList/changeState/', //优惠券展示/隐藏
        findBroadcastSessionInfo:'web/broadcast/findBroadcastSessionInfo/',/* 查询直播数据 */
        findChatRoomOrderInfo:'web/broadcast/findChatRoomOrderInfo/',/* 查询订单数据 */
        getUnfinishedBroadcastList:'/web/broadcast/getUnfinishedBroadcastList',/* 获取直播间信息 */
    }
}
export default obj;